import Vue from 'vue'
import { VueEditor } from 'vue2-editor'

Vue.component("VueEditor", VueEditor)
